<template>
  <div class="f_wrapper">
    <b-form @submit="onSubmit" @reset="onReset" v-if="show">
      <b-row>
        <b-col>
          <b-form-group
            id="input-group-1"
            label="챕터"
            label-for="input-chapter"
            label-size="default"
            label-cols-sm="4"
            label-cols-lg="3"
          >
            <b-form-input
              id="input-chapter"
              v-model="form.chapter"
              placeholder="챕터(digit)"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            id="input-group-1"
            label="유닛"
            label-cols-sm="4"
            label-cols-lg="3"
            label-for="input-unit"
          >
            <b-form-input
              id="input-unit"
              v-model="form.unit"
              placeholder="유닛(digit)"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label="문제순서"
            label-size="sm"
            label-cols-sm="4"
            label-cols-lg="3"
            label-for="input-order"
          >
            <b-form-input
              id="input-order"
              v-model="form.order"
              placeholder="digit"
              size="sm"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <div class="gray100">
        <b-form-group label="학습유형">
          <b-form-radio-group
            v-model="std_type_selected"
            :options="std_type_options"
            name="radio-options1"
          ></b-form-radio-group>
        </b-form-group>
      </div>

      <div>
        <b-card no-body>
          <b-tabs card>
            <b-tab title="개별문항" active>
              <b-card-text>
                <multiselect
                  v-model="intent_value"
                  :options="intent_options"
                  :custom-label="nameWithLang"
                  placeholder="Select one"
                  label="name"
                  track-by="name"
                ></multiselect>

                <div class="gray100">
                  <b-form-group label="문제유형">
                    <b-form-radio-group
                      id="radio-group-2"
                      v-model="q_selected"
                      :options="q_type"
                      @change="change_qtype"
                      name="radio-options"
                    ></b-form-radio-group>
                  </b-form-group>
                </div>

                <b-form-group
                  label="지시문"
                  label-for="input-statement"
                  description="지시문입력"
                  v-if="1 == 1"
                >
                  <b-form-input
                    id="input-statement"
                    v-model="form.statement"
                    placeholder="지시문을 입력하세요"
                  ></b-form-input>
                </b-form-group>

                <b-form-group label="문제" label-for="input-question">
                  <b-form-input
                    id="input-question"
                    v-model="form.question"
                    placeholder="문항을 입력하세요"
                  ></b-form-input>
                </b-form-group>

                <AnswerItem
                  :answer="answer"
                  v-bind:key="answer.num"
                  v-for="answer in answers"
                />
                <b-row>
                  <b-col>
                    <b-form-group>
                      <b-button block size="sm" @click="appendAnswer">
                        정답추가(+)
                      </b-button>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col>
                    <b-form-group label="해석">
                      <b-textarea></b-textarea>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-group label="해설">
                      <b-textarea></b-textarea>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <FileUpload fileobj="fileobj1" />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-group label="동영상" label-cols="2">
                      <b-form-input placeholder="http://~"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="2">
                    <b-form-input placeholder="from(00:00:00)"></b-form-input>
                  </b-col>
                  <b-col cols="2">
                    <b-form-input placeholder="to(00:00:00)"></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-group>
                      <b-button block size="sm"> 동영상추가(+) </b-button>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col>
                    <b-form-group>
                      <b-form-file
                        v-model="file1"
                        placeholder="음원"
                        drop-placeholder="Drop file here..."
                      ></b-form-file>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col>
                    <b-form-group label="난이도*">
                      <b-form-checkbox-group
                        v-model="lvl_selected"
                        :options="lvl_type"
                        name="buttons-1"
                        button-variant="info"
                        buttons
                      ></b-form-checkbox-group>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col>
                    <b-form-group label="어휘" label-cols="2">
                      <b-form-input />
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group label="어휘" label-cols="2">
                      <b-form-input />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card-text>
            </b-tab>
            <b-tab title="그룹문항">
              <b-card-text> </b-card-text>
            </b-tab>
          </b-tabs>
        </b-card>
      </div>

      <b-button type="submit" variant="primary">Submit</b-button>
      <b-button type="reset" variant="danger">Reset</b-button>
    </b-form>
    <Editor />
    <hr />
    <Editor />
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import AnswerItem from "@/components/AnswerItem";
import FileUpload from "@/components/FileUpload";
import Editor from "@/components/Editor";
import * as R from "ramda";
export default {
  components: {
    Multiselect,
    AnswerItem,
    FileUpload,
    Editor,
  },

  computed: {
    answers() {
      return this.$store.state.answers;
    },
    sample() {
      return this.$store.state.fileobj1;
    },
    intent_options() {
      return this.$store.state.intent_options;
    },
  },
  data() {
    return {
      form: {
        email: "",
        name: "",
        food: null,
        order: "",

        checked: [],
      },
      show: true,
      std_type_selected: "second",
      std_type_options: [
        { text: "구문/영작훈련", value: "first", disabled: true },
        { text: "문풀훈련", value: "second", disabled: false },
      ],
      q_selected: "first",
      q_type: [
        { text: "단답형", value: "first" },
        { text: "선택형", value: "second", disabled: false },
        { text: "선다형", value: "three", disabled: false },
        { text: "어순배열", value: "three", disabled: false },
      ],
      file1: null,
      lvl_selected: [],
      lvl_type: [


      { text: "초저", value: "1" },
      { text: "초고", value: "2" },

      { text: "중1", value: "3", disabled: false },
      { text: "중2", value: "4", disabled: false },
      { text: "중3", value: "5", disabled: false },

      { text: "고1", value: "6", disabled: false },
      { text: "고2", value: "7", disabled: false },
      { text: "고3", value: "8", disabled: false },

      { text: "공무원 초급", value: "9", disabled: false },
      { text: "공무원 실전", value: "10", disabled: false },

      ],
      intent_type: [
        { name: "Vue.js", language: "JavaScript" },
        { name: "Rails", language: "Ruby" },
        { name: "Sinatra", language: "Ruby" },
        { name: "Laravel", language: "PHP" },
        { name: "Phoenix", language: "Elixir" },
      ],
      intent_value: "",
    };
  },
  methods: {
    nameWithLang({ d1, d2, d3 }) {
      return `${d1} -> ${d2} -> ${d3}`;
    },
    onSubmit(evt) {
      evt.preventDefault();
      // alert(JSON.stringify(this.form));
    },
    onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.form.email = "";
      this.form.name = "";
      this.form.food = null;
      this.form.checked = [];
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },

    change_qtype(arg) {
      console.log(arg);
    },

    //정답 추가(+)
    appendAnswer() {
      this.$store.dispatch("appendAnswer");
    },
    reorderAnswer() {
      let i = 0;
      this.answers = R.map((n) => {
        n.num = "" + (i + 1);
        i++;
        return n;
      }, this.answers);
    },
  },
};
</script>


<style lang="scss" scoped>
@import "@/styles/_variables.scss";

.gray100 {
  background-color: $gray200;
  padding: 10px 15px 10px 15px;
  border-radius: 5px;
  margin-bottom: 10px;
  margin-top: 10px;
}
</style>